import axios from 'axios'
import Store from '../../store'
import {
  errorHandler,
  successHandler,
  generateNoOptionsQuery
} from '../helpers/handler'
import { BASEURL } from '../const'

const URL = `${BASEURL}/transactions`

export default {
  transactions() {
    return {
      addImageToTransaction: async ({ images = [], trxId }) => {
        const endpoint = `${URL}/${trxId}/image`
        const formData = new FormData()
        images.forEach((i) => formData.append('images', i))
        try {
          const res = await axios.put(endpoint, formData, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers,
              'Content-Type': 'multipart/form-data'
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      // &type=${type}&category=${category}
      // { type, category }
      getAll: async (populate, limit = 0) => {
        // "image"/"images" are `select: false` on the Trx schema, so they
        // are hidden from every query by default. Re-including them with
        // the "+field" select syntax (a query-service feature the backend
        // already supports) is the only way the gift card tab can show the
        // user's originally-uploaded card photo alongside declineImages.
        const endpoint = `${URL}/user${generateNoOptionsQuery(
          populate,
          limit
        )}&user=${Store.state.user.user._id}&select=${encodeURIComponent(
          '+image +images'
        )}`

        // console.log(endpoint)
        try {
          const res = await axios.get(endpoint, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      // Server-side filtered/paginated Sales fetch - moves the tab off
      // "fetch everything with limit=0 then filter in the browser" and
      // onto passing the filter to the API instead.
      getSales: async ({ status, page = 1, limit = 10 } = {}) => {
        const offset = (page - 1) * limit
        let endpoint = `${URL}/user${generateNoOptionsQuery(
          ['currency', 'bank', 'coin'],
          limit
        )}&user=${Store.state.user.user._id}&select=${encodeURIComponent(
          '+image +images'
        )}&type=sale&category=coin&offset=${offset}`
        if (status && status !== 'all') {
          endpoint += `&status=${status}`
        }
        try {
          const res = await axios.get(endpoint, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      // Same server-side filtered/paginated pattern as getSales, for the
      // Purchase tab.
      getPurchases: async ({ status, page = 1, limit = 10 } = {}) => {
        const offset = (page - 1) * limit
        let endpoint = `${URL}/user${generateNoOptionsQuery(
          ['currency', 'bank', 'coin'],
          limit
        )}&user=${Store.state.user.user._id}&select=${encodeURIComponent(
          '+image +images'
        )}&type=purchase&offset=${offset}`
        if (status && status !== 'all') {
          endpoint += `&status=${status}`
        }
        try {
          const res = await axios.get(endpoint, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      // Same pattern, for the Giftcard tab.
      getGiftcards: async ({ status, page = 1, limit = 10 } = {}) => {
        const offset = (page - 1) * limit
        let endpoint = `${URL}/user${generateNoOptionsQuery(
          ['giftcard'],
          limit
        )}&user=${Store.state.user.user._id}&select=${encodeURIComponent(
          '+image +images'
        )}&category=giftcard&offset=${offset}`
        if (status && status !== 'all') {
          endpoint += `&status=${status}`
        }
        try {
          const res = await axios.get(endpoint, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      getFundTransfer: async (...params) => {
        const endpoint = `${BASEURL}/transfers/user${generateNoOptionsQuery(
          ...params
        )}`
        try {
          const res = await axios.get(endpoint, {
            headers: {
              ...Store.getters['user/getRequestHeaders'].headers
            }
          })
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      },
      calculatePointsToEarn: async (amount) => {
        const endpoint = `${URL}/calculate-points`
        try {
          const res = await axios.post(
            endpoint,
            { amount: Number(amount) },
            {
              headers: {
                ...Store.getters['user/getRequestHeaders'].headers
              }
            }
          )
          return successHandler(res)
        } catch (error) {
          return errorHandler(error)
        }
      }
    }
  }
}
